import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100vw", height: "100vh",
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: theme.palette.background ? theme.palette.background.default : "#f5f5f5",
    },
    paper: {
        display: "flex", flexDirection: "column", alignItems: "center",
        padding: "40px 32px", borderRadius: 12,
        backgroundColor: "#fff",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        width: "100%", maxWidth: 400,
    },
    title: { marginBottom: 24, fontWeight: 700 },
    form: { width: "100%", marginTop: 8 },
    submit: { margin: theme.spacing(3, 0, 2) },
}));

const ResetPassword = () => {
    const classes = useStyles();
    const history = useHistory();
    const { token } = useParams();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { toast.error("As senhas nao coincidem"); return; }
        if (password.length < 6) { toast.error("A senha deve ter pelo menos 6 caracteres"); return; }
        setLoading(true);
        try {
            await openApi.post("/auth/reset-password", { token, password });
            toast.success("Senha redefinida com sucesso!");
            history.push("/login");
        } catch (err) {
            toastError(err);
        }
        setLoading(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5" className={classes.title}>
                    Nova senha
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined" margin="normal" required fullWidth
                        label="Nova senha" type="password"
                        value={password} onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        variant="outlined" margin="normal" required fullWidth
                        label="Confirmar senha" type="password"
                        value={confirm} onChange={(e) => setConfirm(e.target.value)}
                    />
                    <Button
                        type="submit" fullWidth variant="contained" color="primary"
                        className={classes.submit} disabled={loading}
                    >
                        {loading ? "Salvando..." : "Redefinir senha"}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
